import { GET_PLC_SAFETY_ZONES, GET_PLC_SAFETY_ZONES_SUCCESS, GET_PLC_SAFETY_ZONES_ERROR } from './actionTypes';

export const getPlcSafetyZones = (user) => ({
  type: GET_PLC_SAFETY_ZONES,
  payload: { user },
});

export const getPlcSafetyZonesSuccess = (zones) => ({
  type: GET_PLC_SAFETY_ZONES_SUCCESS,
  payload: { zones },
});

export const getPlcSafetyZonesError = (error) => ({
  type: GET_PLC_SAFETY_ZONES_ERROR,
  payload: error,
});
